import { FC, useEffect, useRef } from 'react';
import CheckDecorator, { CheckDecoratorProps } from '../CheckDecorator';

import styles from './Checkbox.module.scss';

export type CheckboxProps = {
  checked: boolean;
  className?: string;
  onChange: (checked: boolean) => void;
  onBlur?: () => void;
  disabled?: boolean;
  indeterminate?: boolean;
  isVisuallyHidden?: boolean;
  id?: string;
  size?: CheckDecoratorProps['size'];
};

const Checkbox: FC<CheckboxProps> = ({
  checked,
  className,
  onChange,
  onBlur = () => {},
  disabled = false,
  indeterminate = false,
  isVisuallyHidden = false,
  id = '',
  size = 'medium',
}) => {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    const input = ref.current;
    if (input) {
      input.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  const input = (
    <input
      id={id}
      type="checkbox"
      ref={ref}
      disabled={disabled}
      checked={checked && !indeterminate}
      onChange={(e) => onChange(e.target.checked)}
      onBlur={onBlur}
    />
  );

  if (isVisuallyHidden) {
    // This allows for svg handling of checkbox
    return (
      <div className={styles.isVisuallyHidden}>{input}</div>
    );
  }
  return (
    <CheckDecorator
      className={className}
      disabled={disabled}
      size={size}
    >
      {input}
    </CheckDecorator>
  );
};

export default Checkbox;
